//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'ChoosePeriod',
    props: {
        period:String,
    },
    data: () => {
        return {
        };
    },
    computed: {
        periodOptions: {
            get: function () {
                return this.period;
            },
            set: function (newValue) {
                this.$emit('input', newValue)
            },
        },
    },
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    updated () {
    },
};



// WEBPACK FOOTER //
// ./scripts/vue/components/choose-plan/ChoosePeriod.vue